import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useMultiFormContext } from "../modules/Common/components/MultiForm";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { isNull } from "lodash";
import AccountMetaAction from "../modules/Overview/pages/actions/modals/actions/AccountMetaAction";

const { PUBLIC_URL } = process.env;

const convertUTCToLocalDate = datetime => {
    if (datetime?.toLocaleString()?.trim().length !== 10) {
        datetime = datetime?.replace("Z", "")
        const curDate = new Date();
        datetime = (new Date(datetime)).getTime() - (curDate.getTimezoneOffset() * 60000);
    }
    return datetime ? new Date(datetime) : null
}

export const formatDay = datetime => {
    const event = new Date(convertUTCToLocalDate(datetime));
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return datetime ? event.toLocaleDateString('en-US', options) : "None";
}
export const formatDate = datetime => {
    const event = new Date(convertUTCToLocalDate(datetime));
    const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    };
    return datetime ? <span style={{ whiteSpace: "nowrap" }}>{event.toLocaleDateString('en-US', options)}</span> : "None";
}

export const formatLongDate = datetime => {
    const event = new Date(convertUTCToLocalDate(datetime));
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return datetime ? event.toLocaleDateString('en-US', options) : "None";
}

export const formatMonthYear = datetime => {
    const event = new Date(convertUTCToLocalDate(datetime));
    const options = { month: 'short', year: 'numeric' };
    return datetime ? event.toLocaleDateString('en-US', options)?.replace(' ', ', ') : "None";
}

export const formatAdminType = adminLevel => {
    return ["", "Admin", "Super Admin", "Admin"][adminLevel];
}

export const statusColourName = status => {
    const color = {
        pending_confirmation: "info",
        pending: "info",
        processing: "warning",
        consider: "warning",
        executed: "primary",
        success: "primary",
        active: "primary",
        completed: "primary",
        complete: "primary",
        clear: "primary",
        disabled: "danger",
        verified: "primary",
        approved: "primary",
        deleted: "danger",
        cancelled: "danger",
        declined: "danger",
        failed: "danger",
        rejected: "danger",
        flagged: "danger",
        successful: "primary",
        level_two_pending: "info",
    };
    return color[status?.toLowerCase()] ?? "muted";
}
export const formatStatus = status => {
    const color = {
        pending_confirmation: "info",
        pending: "info",
        processing: "warning",
        consider: "warning",
        executed: "primary",
        success: "primary",
        active: "primary",
        completed: "primary",
        complete: "primary",
        clear: "primary",
        enabled: "primary",
        disabled: "danger",
        verified: "primary",
        approved: "primary",
        deleted: "danger",
        cancelled: "danger",
        declined: "danger",
        failed: "danger",
        flagged: "danger",
        rejected: "danger",
        reject: "danger",
        successful: "primary",
        paid: "primary",
        pending_document: "info",
        suspended: "danger",
        manual_processing: "warning",
        pending_review: "info",
        tech_support: "warning",
        corrected: "primary",
        tech_resolved: "primary",


        
    };
    return status ? (<span className={`label label-lg label-light-${color[status?.toLowerCase()]} label-inline`}>
        {status?.replace(/_/g, " ")}
    </span>) : null;
}

export const formatUsername = (userId, username, email = "", accountId = null, path = null) => {
    let url = `${PUBLIC_URL}/users/view/${userId}`;
    if (accountId) {
        url += `/account-information/${accountId}`
    }
    if (path) {
        url += `/${path}`
    }
    return <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>
        <div>
            {
                username
                    ? <a href={url} rel="noopener noreferrer"
                        target="_blank"
                        className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                        {username.substring(0, 20) + (username.length > 20 ? "..." : "")}
                    </a>
                    : email
            }
        </div>
    </div>
}
export const userProfileLink = (userId, accountId) => {
    return `${PUBLIC_URL}/users/view/${userId}/account-information/${accountId}`;
};

export const stalledTransactionLink = ( flaggedId) => {
    const query = new URLSearchParams({ query: flaggedId }).toString();
    return `/stalled-transaction/trove/all/?${query}`;
  };
  
  
  


export const formatMigrationStatus = (status) => {
    switch (status) {
        case "-2":
            return formatStatus("failed")
        case "-1":
            return formatStatus("pending")
        case "0":
            return formatStatus("uninitialized")
        case "1":
            return formatStatus("success")
        default:
            return formatStatus("unknown")
    }
}

export const formatAmount = (currency, amount) => {
    const currencyObj = { NGN: "₦", USD: "$" };
    return `${currencyObj[currency?.toUpperCase()] ?? ""}${convertToNumber(amount)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? 0}`
}

export const convertToNumber = val => {
    const value = val?.toLocaleString()?.replace(/[,]/g, '');
    return parseFloat(value) ? parseFloat(value) : 0;
}

export const formatNumber = val => {
    return val ? convertToNumber(val)?.toLocaleString() : val;
}

export const formatAsset = (id, symbol, imageUrl) => {
    return <div className="d-flex align-items-center">
        <span
            style={{
                height: "40px",
                width: "40px",
            }}
            className="mr-3 border svg-icon menu-icon rounded-circle bg-white d-flex align-items-center justify-content-center"
        >
            <img
                alt={symbol[0]}
                height="25px"
                width="25px"
                src={imageUrl}
                onError={e => {
                    e.target.onerror = null;
                    e.target.src = toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")
                }}
            />
        </span>
        <div className="flex-column align-items-start">
            <a href={`${PUBLIC_URL}/instruments/${id}`} rel="noopener noreferrer" target="_blank" className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                {symbol}
            </a>
        </div>
    </div>
}

export const formatActivity = row => {
    return <div className="d-flex align-items-center">
        <div className="symbol symbol-50 flex-shrink-0 mr-4">
            <span className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                {transactionType(row)}
                <span className="text-muted pl-2">
                    {transactionCat(row)}
                </span>
            </span>
        </div>
    </div>
}

export const formatSocialPostEvent = post => {
    switch(post?.type) {
        case "transaction":
            const transaction = post?.postTransaction;
            let verb = "";
            let color = "primary";
            switch (transaction?.type) {
                case "BUY":
                    verb = "Bought";
                    break;
                case "SELL":
                    verb = "Sold";
                    color = "danger";
                    break;
                case "DIV":
                    verb = "Received dividends for"
            }
            return <div className="font-weight-bolder d-flex align-items-center font-size-lg">
                <div className={`bg-${color} rounded-circle mr-3`} style={{ height: "10px", width: "10px" }}></div>
                <span>{verb} {transaction?.symbol} at {formatAmount(transaction?.currency, transaction?.price)}</span>
            </div>
        case "reply":
            return <div className="d-flex align-items-center">
            
            </div>
        default:
          return null
    }
}

/* Extract Error Message */
export const errorMessage = error => {
    if (!error) {
        return "An error occurred";
    }

    if (typeof error === "string") {
        return error.trim() || "An error occurred";
    }

    let message = "";

    if (
        error.response &&
        error.response.data &&
        error.response.data.responseCode === "99" &&
        error.response.data.responseMessage === "no safelock for Id"
    ) {
        message = "No safelock found";
    } else if (error.response && error.response.data.error) {
        message = error.response.data.error;
    } else if (error.response && typeof error.response.data.message === "object") {
        for (let key in error.response.data.message) {
            message += `${error.response.data.message[key]} `;
        }
    } else if (error.response && typeof error.response.data.message === "string") {
        message = error.response.data.message;
    } else {
        message = error.message;
    }

    if (typeof message !== "string") {
        try {
            message = JSON.stringify(message);
        } catch {
            message = "";
        }
    }

    return message?.trim() || "An error occurred";
};


/* Transaction type image */
export const transactionImage = row => {
    let type = row?.tranType?.toLowerCase();
    if (row?.comment?.includes("Transfer from")) {
        type = "transferIn";
    }
    else if (row?.comment?.includes("Transfer to")) {
        type = "transferOut";
    }

    const img = {
        withdraw: "img-41.jpg",
        dividend: "img-6.jpg",
        deposit: "img-54.jpg",
        buy: "img-60.jpg",
        sell: "img-18.jpg",
        transferOut: "img-8.jpg",
        transferIn: "img-71.jpg"
    }
    return `/media/stock-600x400/${img[type] ?? "img-10.jpg"}`;
}

/* Transaction category */
export const transactionCat = row => {
    if (row?.comment?.includes("Transfer from")) {
        return `CREDIT ${row?.comment?.includes("stock gifting") ? "- STOCK GIFTING" : ""}`;
    }
    if (row?.comment?.includes("Transfer to")) {
        return `DEBIT ${row?.comment?.includes("stock gifting") ? "- STOCK GIFTING" : ""}`;
    }
    const cat = { withdraw: "DEBIT", deposit: "CREDIT", buy: "DEBIT", sell: "CREDIT" }
    return cat[row?.tranType?.toLowerCase()] ?? "OTHERS";
}

/* Transaction Type */
export const transactionType = row => {
    if (row?.comment?.includes("Transfer from") || row?.comment?.includes("Transfer to")) {
        return "TRANSFER";
    }
    return row.tranType?.toUpperCase();
}

/* Delay Execution logic */
export const debounce = function (callback, delay) {
    let timeout;
    return function (e) {
        e.persist();
        clearTimeout(timeout);
        timeout = setTimeout(_ => callback(e), delay);
    }
}

/* Mimic Axios Cancel Function Before Set */
export const initialCancelFunction = (msg = null) => {
}

// Capitalize first character
export const ucFirst = s => {
    return s && s[0].toUpperCase() + s.slice(1);
}

// Confirm Kyc Requirement Completed
export const completeKyc = kyc => {
    if (!kyc) {
        return false;
    }

    // Fields Check
    for (const key in kyc) {
        const field = kyc[key];
        if (Array.isArray(kyc[key]) && kyc[key].length === 0) {
            return false;
        }
        if (key !== "riskProfile" && key !== "trustData" && field && typeof field === "object" && Object.keys(field).length === 0) {
            return false
        }
        if ((key === "firstName" || key === "lastName") && field === "") {
            return false;
        }
    }

// Document Check
const combineCheck = { "picture": false, "address": false }
for (const doc of kyc.docs) {
    // Use 1 doc as Picture and Proof of Address as criteria
    if (doc.status?.toUpperCase() === "APPROVED" && doc.type?.toUpperCase() === "PICTURE_ID_PROOF_OF_ADDRESS") {
        return true;
    }

    // Use 2 docs Picture and Proof of Address as criteria
    if (doc.status?.toUpperCase() === "APPROVED" && doc.type?.toUpperCase() === "PICTURE_ID") {
        combineCheck.picture = true;
    }

    if (doc.status?.toUpperCase() === "APPROVED" && doc.type?.toUpperCase() === "PROOF_OF_ADDRESS") {
        combineCheck.address = true;
    }
}

return combineCheck.picture && combineCheck.address;
}

// Create deep object where applicable
export const formToDeepObject = (obj, objGroup = null) => {

    const reformat = {}
    for (let key in obj) {
        let innerKey = key.match(/\[(.*?)\]/);
        if (innerKey) {
            let outerKey = key.match(/(.*?)\[/)[1];
            if (!reformat[outerKey]) {
                reformat[outerKey] = {};
            }

            reformat[outerKey][innerKey[1]] = obj[key] === "true" ? true : obj[key];
        } else {
            reformat[key] = obj[key];
        }
    }

    // Group all object under objGroup name if applicable
    if (objGroup !== null) {
        reformat[objGroup] = {};
        for (let key in reformat) {
            if (key !== objGroup && !!reformat[key] && typeof reformat[key] === "object") {
                reformat[objGroup] = { ...reformat[objGroup], [key]: reformat[key] };
                delete reformat[key];
            }
        }
    }

    return reformat
}

// User Permission check
export const permissionAllow = (user, perm, permissionType = "read") => {
    return user?.adminLevel === 2 || !!user?.permissions?.[perm?.name]?.[permissionType]
}

// Return display Class based on permission
export const permissionCssClass = (user, perm, permissionType = "read") => {
    return permissionAllow(user, perm, permissionType) ? "" : "d-none";
}


export const diffCheck = (old, latest) => {
    if (old === latest) {
        return latest;
    } else if (latest) {
        return <> <strike>{old}</strike> {old && latest ? <> &rarr;</> : ""} <span
            className="text-primary">{latest ?? ""}</span></>;
    } else {
        return old ?? "";
    }
}

/* Read a file asynchronously */
export const readFileAsync = async (file) => {
    /* Convert File to base64 */
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
    })
}

// Download a file
export const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
}

// Synchronize Formik data with MultiForm context
export const FormikMultiFormSync = ({ name, isRequired = true }) => {
    // Grab values from context
    const { values, isValid, dirty } = useFormikContext();
    const { upsertValue } = useMultiFormContext();

    useEffect(() => {
        upsertValue(name, { data: values, isValid: isValid || !isRequired, isDirty: dirty });
    }, [isValid, values, dirty, upsertValue, isRequired, name]);

    return null;
};

// Dynamically support children of types Function or React.Node
export function NodeOrFunction({ children, ...props }) {
    return children instanceof Function ? children(props) : children
}

// Format form title with validation indicator
export const formatFormTitle = ({ title, isValid, isRequired = true }) => {
    return <div className={"d-flex mb-3 align-items-center"}>
        <div
            className={`bg-light-danger p-3 mr-3 rounded-circle svg-icon svg-icon-danger ${(isValid || !isRequired) && "d-none"}`}>
            <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-1-circle.svg")} />
        </div>
        <div
            className={`bg-light-primary p-3 mr-3 rounded-circle svg-icon svg-icon-primary ${(!isValid && isRequired) && "d-none"}`}>
            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")} />
        </div>
        <div>
            <h4 className="font-weight-bolder mb-0">{title}</h4>
            {!isRequired && <div className={"text-muted"}>Not Required</div>}
        </div>
    </div>
}

// Combine Data from multiple forms
export const combineMultiFormData = (data) => {
    const normalData = { data: {}, isValid: true, isDirty: false }

    for (const [key, value] of Object.entries(data)) {
        normalData.data[key] = value.data
        normalData.isValid = normalData.isValid && value.isValid
        normalData.isDirty = normalData.isDirty || value.isDirty
    }

    return normalData
}


/**
 * Truncate long String
 * @param {string} id
 * @returns truncated version
 */
export const truncateString = (title, len = 150) => {
    if (!title) return null;
    return `${title?.substr(0, len)}${title.length > len ? ".." : ""}`;
}

// Calculate balance after order is completed
export const getOrderBalanceAfter = ({ status, accountBalance, total, side }) => {
    if (status?.toLowerCase() !== "completed") return accountBalance
    return side?.toLowerCase() === "buy" ? accountBalance - total : accountBalance + total
}

const TRANSACTION_DEDUCTION_TYPES = new Set([
    "withdraw",
    "buy",
    "fee",
    "divtax",
    "reward_redemption",
    "bill_payment",
    "reversal_out",
    "commission",
    "divnra",
    "divfee",
    "intra_transfer_out",
    "inter_transfer_out",
    "earn_investment",
    "commercial_paper_subscription",
    "cash_correction_out",
]);

// Calculate balance after transaction is executed
export const getTransactionBalanceAfter = ({ tranStatus, accountBal, tranAmount, tranType, extras }) => {
    if (tranStatus?.toLowerCase() !== "executed") return accountBal
    if (extras && !isNull(extras) && extras.accountBalance) {
        extras = JSON.parse(extras);
        return extras.accountBalance;
    }
    
    return TRANSACTION_DEDUCTION_TYPES.has(tranType?.toLowerCase()) ? accountBal - tranAmount : accountBal + tranAmount;
}

export const getTransactionBalanceBefore = ({ tranStatus, accountBal, tranAmount, tranType, extras }) => {
    if (tranStatus?.toLowerCase() !== "executed") return accountBal
    
    if (extras && !isNull(extras) && extras.accountBalance && extras.accountAmount) {
        extras = JSON.parse(extras);
        return extras.accountBalance - extras.accountAmount;
    }
    return accountBal;
}
export const maskText = (text, padding = 0) => {
    let newText = ""
    let length = text?.length || 0
    for (let i = 0; i < length; i++) {
        if (i < length - padding && i >= padding) {
            newText += "*";
        } else {
            newText += text[i];
        }
    }
    return newText;
}
